import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const API_URL = "https://ger.wa.48.defaultbot.com/v4";

export default function ProfileSearch() {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const navigate = useNavigate();

    const searchUser = async () => {
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }

        const value = query.trim();
        if (!value) {
            setResults([]);
            setHasSearched(false);
            return;
        }

        setIsSearching(true);
        setHasSearched(false);
        setResults([]);

        const headers = { Authorization: `Bearer ${token}` };
        const username = value.replace(/^@/, '');
        const email = value.replaceAll('mailto:', '').toLowerCase();
        const searches = [
            axios.post(`${API_URL}/get-id-by-username`, { username }, { headers })
                .then(({ data }) => data.ok ? { id: data.id, source: 'username' } : null)
                .catch(() => null),
            axios.post(`${API_URL}/get-id-by-email`, { email }, { headers })
                .then(({ data }) => data.ok ? { id: data.id, source: 'email' } : null)
                .catch(() => null),
        ];

        if (/^\d+$/.test(value)) {
            searches.push(Promise.resolve({ id: value, source: 'chat_id' }));
        }

        const matches = await Promise.all(searches);
        const combinedResults = matches.filter(Boolean).reduce((items, match) => {
            const existing = items.find(item => String(item.id) === String(match.id));
            if (existing) {
                existing.sources.push(match.source);
            } else {
                items.push({ ...match, sources: [match.source] });
            }
            return items;
        }, []);

        if (combinedResults.length === 1) {
            navigate('/user/' + combinedResults[0].id);
        } else {
            setResults(combinedResults);
            setHasSearched(true);
        }
        setIsSearching(false);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        searchUser();
    };

    const sourceLabel = {
        username: 'username',
        email: 'email',
        chat_id: 'chat_id',
    };

    return (
        <div className="content-block t-container">
            <div className="t-content split">
                <div className="page-header profile-search-header">
                    <h1>Поиск пользователя</h1>
                </div>
                <form className="profile-search-form" onSubmit={handleSubmit}>
                    <input
                        value={query}
                        placeholder="ник в тг, почта или chat_id"
                        onChange={event => setQuery(event.target.value)}
                        type="text"
                        className="t-input"
                    />
                    <button className="t-button t-primary" type="submit" disabled={isSearching}>
                        {isSearching ? 'Поиск...' : 'Найти пользователя'}
                    </button>
                </form>
                {results.length > 0 && (
                    <div>
                        <h2>Результаты поиска</h2>
                        {results.map(result => (
                            <button
                                className="t-button"
                                key={result.id}
                                onClick={() => navigate('/user/' + result.id)}
                            >
                                {result.id} ({result.sources.map(source => sourceLabel[source]).join(', ')})
                            </button>
                        ))}
                    </div>
                )}
                {hasSearched && results.length === 0 && <p>Пользователь не найден</p>}
            </div>
        </div>
    );
}
